<template>
    <div>
        <div v-if="Permission.VIEW_SERVER_STATS" class="mb-3">
            <div class="d-flex flex-lg-row gap-3">
                <div class="w-50">
                    <cpu-utilization/>
                </div>
                <div class="w-50">
                    <hard-disk-usage/>
                </div>
            </div>
        </div>
        <div class="grid grid-cols-2 gap-3">
            <div v-for="card in dashboardCards">
                <DashboardCard :key="card.title"
                               :title="card.title"
                               :icon-class="card.iconClass"
                               :text="card.text"
                               :link="card.link"
                               :disabled="noStores && card.disableIfNoStore"
                               :is-inertia-link="card.isInertiaLink"
                               :target-blank="card.targetBlank"
                />
            </div>
        </div>
    </div>

</template>

<script>
import {PermissionsMixin} from '@js/permissions';
import CpuUtilization from '@components/Widgets/Server/CpuUtilization';
import HardDiskUsage from '@components/Widgets/Server/HardDiskUsage';
import MemoryUsage from '@components/Widgets/Server/MemoryUsage';
import DashboardCard from '@components/Dashboard/DashboardCard';

export default {
    components: {
        DashboardCard,
        MemoryUsage,
        HardDiskUsage,
        CpuUtilization,
    },

    mixins: [PermissionsMixin],

    methods: {
        showModal() {
            Swal.fire({
                title: __('general.agb.title'),
                showDenyButton: false,
                showCancelButton: true,
                confirmButtonText: this.__('actions.consent'),
                cancelButtonText: this.agbDeadlineExpired ? this.__('actions.abort_and_logout') : this.__('actions.abort'),
                html: __('general.agb.text'),
                width: '75%',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$inertia.post(this.$route('agb.accept'), {
                        only: ['agbAccepted'],
                        onSuccess: () => {
                            toastr.success(__('general.agb.accepted'));
                        }
                    });
                } else {
                    if (this.agbDeadlineExpired) {
                        this.$inertia.visit(this.$route('logout'))
                    }
                }
            });
        },
    },

    computed: {
        noStores() {
            return this.stores.length === 0;
        },

        dashboardCards() {
            let cards = [
                {
                    title: __('dashboard.cards.instructions.title'),
                    text: __('dashboard.cards.instructions.text'),
                    iconClass: 'fas fa-info-circle',
                    link: document.documentElement.lang === 'de' ? '/docs/2024-01 Struktur Dashboard - Händler V1.pdf' : '/docs/2024-01 Dashboard  Structure - Sellers V1 (ENGL).pdf',
                    disableIfNoStore: false,
                    isInertiaLink: false,
                    targetBlank: true,
                },
                {
                    title: __('dashboard.cards.stores.title'),
                    text: __('dashboard.cards.stores.text'),
                    iconClass: 'fa fa-store',
                    link: this.$route('stores.index'),
                    disableIfNoStore: false,
                    isInertiaLink: true,
                    targetBlank: false,
                },
                {
                    title: __('dashboard.cards.requests.title'),
                    text: __('dashboard.cards.requests.text'),
                    iconClass: 'fas fa-envelope-open-text',
                    link: this.$route('user.requests.index'),
                    disableIfNoStore: false,
                    isInertiaLink: false,
                    targetBlank: false,
                },
                {
                    title: __('dashboard.cards.orders.title'),
                    text: __('dashboard.cards.orders.text'),
                    iconClass: 'fas fa-exchange-alt',
                    link: this.$route('orders.index'),
                    disableIfNoStore: true,
                    isInertiaLink: true,
                    targetBlank: false,
                },
                {
                    title: __('dashboard.cards.ftp.title'),
                    text: __('dashboard.cards.ftp.text'),
                    iconClass: 'fas fa-server',
                    link: this.$route('ftp.account.settings'),
                    disableIfNoStore: false,
                    isInertiaLink: true,
                }
            ];

            if (this.stores.length > 0) {
                cards.push({
                    title: __('dashboard.cards.articles.title'),
                    text: __('dashboard.cards.articles.text'),
                    iconClass: 'fas fa-boxes',
                    link: this.$route('store.articles.index', [this.stores[0].id]),
                    disableIfNoStore: true,
                    isInertiaLink: true,
                    targetBlank: false,
                });
            }

            return cards;
        }
    },

    props: {
        stores: Array,
        agbAccepted: Boolean,
        agbDeadlineExpired: Boolean,
    },

    mounted() {
        if (!this.agbAccepted) {
            this.showModal();
        }
    },
};
</script>
